<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="false" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalFinishedProjectVisible" vm-title='Finish Project')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("projects.completion_date")' :danger="$v.form.completion_date.$invalid && $v.form.completion_date.$model" :danger-text="$t('validation.required', { attribute: $t('projects.completion_date') })" v-model="form.completion_date")
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalFinishProject',
  props: {
    form: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    form: {
      completion_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalFinishedProjectVisible'
    ])
  },
  methods: {
    ...mapActions([
      'actionProjectFinished',
      'setModalFinishedProjectVisible'
    ]),
    async saveRecord () {
      this.form.completion_date = moment(this.form.completion_date).format('YYYY-MM-DD')
      await this.actionProjectFinished(this.form)
    },
    close () {
      this.setModalFinishedProjectVisible(false)
    }
  }
}
</script>
